import React from 'react'

interface TabsLayoutContextType {
  setContainerTabsVisibility: (visible: boolean) => void
  setContainerTabs: (tabs: React.ReactNode) => void
}

const initialValues: TabsLayoutContextType = {
  setContainerTabsVisibility: () => {},
  setContainerTabs: () => {},
}

const TabsLayoutContext = React.createContext<TabsLayoutContextType>(initialValues)

export default TabsLayoutContext
